import React, { useEffect, useState, useCallback } from "react";
import ConfigContext from "./ConfigContext";
import categoriesApi from "../../services/categoriesApi";
import productsApi from "../../services/productsApi";
import stringsApi from "../../services/stringsApi";

const ConfigProvider = ({ children }) => {
    const [categories, setCategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [strings, setStrings] = useState([]);
    const [isLoadingProducts, setIsLoadingProducts] = useState(false);
    
    // Stato per memorizzare il primo prodotto in assoluto (Novità della settimana)
    const [weeklyNewProduct, setWeeklyNewProduct] = useState(null);

    // 1. DICHIARAZIONE FUNZIONI
    const setupData = async () => {
        let response = null;
        let stringsResponse = null;
        try {
            response = await categoriesApi.fetchCategories();
            stringsResponse = await stringsApi.fetchStrings();
        } catch (error) {
            console.error("fetchCategories", error);
        }
        
        if (response?.data?.data) {
            const allCategories = response.data.data;
            setCategories(allCategories);
            
            const firstCategory = allCategories[0];
            if (firstCategory?.id) {
                setSelectedCategory(firstCategory.id);
                
                // 🚀 Recuperiamo i prodotti della prima categoria per estrarre la novità
                try {
                    const prodResponse = await productsApi.fetchProducts(firstCategory.id);
                    // Accediamo alla struttura annidata tipica del tuo backend (es: item.subcategory -> item.data)
                    const firstSubcategoryBlock = prodResponse?.data?.data?.[0];
                    const firstProduct = firstSubcategoryBlock?.data?.[0];
                    
                    if (firstProduct) {
                        setWeeklyNewProduct(firstProduct);
                    }
                } catch (prodError) {
                    console.error("Errore nel recupero della novità della settimana:", prodError);
                }
            }
        }
        if (stringsResponse?.data?.data) {
            setStrings(stringsResponse.data.data);
        }
    };

    // Stabilizza la referenza della funzione
    const getProductsList = useCallback(async () => {
        if (!selectedCategory) return;
        
        setIsLoadingProducts(true);
        let response = null;
        try {
            response = await productsApi.fetchProducts(selectedCategory);
        } catch (error) {
            console.error("getProductsList", error);
        }
        
        if (response?.data?.data) {
            setProducts(response.data.data);
        }
        setIsLoadingProducts(false);
    }, [selectedCategory]);

    // 2. EFFETTI
    useEffect(() => {
        setupData();
    }, []);

    useEffect(() => {
        // Evitiamo di svuotare e ricaricare se la categoria selezionata è la prima 
        // e abbiamo già popolato i prodotti durante il setupData iniziale
        if (selectedCategory) {
            setProducts([]);
            getProductsList();
        }
    }, [selectedCategory, getProductsList]);

    return (
        <ConfigContext.Provider value={{ 
            categories, 
            selectedCategory, 
            setSelectedCategory, 
            products, 
            strings, 
            isLoadingProducts,
            weeklyNewProduct // <-- Esposto nel context per essere usato in Menu.jsx
        }}>
            {children}
        </ConfigContext.Provider>
    );
};

export default ConfigProvider;